import clsx from 'clsx';
import React from 'react';

type SectionWrapper = {
    children: React.ReactNode;
    className?: string;
    fullScreen?: boolean;
};

function SectionWrapper({ children, className, fullScreen = false }: SectionWrapper) {
    return (
        <section className={clsx(className, 'flex justify-center w-full pb-10 lg:pb-25')}>
            <div
                className={clsx(
                    fullScreen
                        ? ''
                        : 'max-w-[1560px] min-w-[300px] tablet:px-20 px-4 mobile:px-10  '
                )}
            >
                {children}
            </div>
        </section>
    );
}

export default SectionWrapper;
